import React from "react";
import PropTypes from "prop-types";
import { Col, FormItem } from "../../common/UIComponents";
import BillingRemarksTable from "./BillingRemarksTable";
import I18n from "../../common/I18n";

const BillingRemarksTabContent = ({ invoice, timeZoneId }) => {
  const remarks = invoice?.remarks || [];

  return (
    <div style={{ padding: "10px 0" }}>
      {remarks && remarks.length > 0 ? (
        <Col sm={24} xs={24} md={24} lg={24}>
          <FormItem label={I18n.t("general.notes")}>
            <BillingRemarksTable data={remarks} timeZoneId={timeZoneId} />
          </FormItem>
        </Col>
      ) : (
        <div style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.45)", padding: 20 }}>
          No notes or remarks available.
        </div>
      )}
    </div>
  );
};

BillingRemarksTabContent.propTypes = {
  invoice: PropTypes.object.isRequired,
};

export default BillingRemarksTabContent;
